import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import api from "../axiosSetup";
import DataTable from "./DataTable";
import cfg from "../../config";

const ZRHaesApplies = () => {
  const [allData, setAllData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("open");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHaesApplies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get("/api/all-haes-applies-zunftrat", {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = res.data || [];

        if (data.length > 0) {
          const firstItem = data[0];
          const hdrs = [{ key: "Anfrager", label: "Anfrager" }];
          for (const key in firstItem) {
            if (key === "Anfrager" || key === "done") continue;
            if (firstItem[key] && typeof firstItem[key] === "object" && "frontendName" in firstItem[key]) {
              hdrs.push({ key, label: firstItem[key].frontendName });
            } else {
              hdrs.push({ key, label: key });
            }
          }
          setHeaders(hdrs);
        }
        setAllData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchHaesApplies();
  }, []);

  const openData = useMemo(
    () => allData.filter((item) => item.done?.value === 0 || item.done?.value === null || !item.done?.value),
    [allData]
  );
  const closedData = useMemo(
    () => allData.filter((item) => item.done?.value === 1),
    [allData]
  );

  const columns = useMemo(
    () =>
      headers.map((h) => ({
        key: h.key,
        label: h.label,
        render: (val) => {
          if (h.key === "Anfrager") {
            return val?.Name || <span className="dt-muted">—</span>;
          }
          if (!val || typeof val !== "object") {
            return val != null ? String(val) : <span className="dt-muted">—</span>;
          }
          const v = val.value;
          if (Array.isArray(v)) {
            return v.length > 0
              ? <span>{v.join(", ")}</span>
              : <span className="dt-muted">Kein Zubehör</span>;
          }
          if (v === true || v === 1) return <span className="dt-badge dt-badge-yes">Ja</span>;
          if (v === false || v === 0) return <span className="dt-badge dt-badge-no">Nein</span>;
          if (v == null) return <span className="dt-muted">—</span>;
          return String(v);
        },
        searchValue: (val) => {
          if (h.key === "Anfrager") return val?.Name ?? "";
          if (!val || typeof val !== "object") return String(val ?? "");
          const v = val.value;
          if (Array.isArray(v)) return v.join(" ");
          return String(v ?? "");
        },
      })),
    [headers]
  );

  const actions = (item) => (
    <div className="dt-actions">
      <button className="dt-btn dt-btn-primary" onClick={() => navigate("/edit-haes-apply", { state: item })}>
        Anfrage bearbeiten
      </button>
    </div>
  );

  const tabConfig = [
    { key: "open", label: "Offene Anfragen", count: openData.length },
    { key: "closed", label: "Abgeschlossene Anfragen", count: closedData.length },
  ];

  const tableData = activeTab === "open" ? openData : closedData;

  return (
    <div className="container-fluid px-3 px-md-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0">Anfragen ({cfg.costumeTerm})</h2>
      </div>
      <DataTable
        data={tableData}
        columns={columns}
        loading={loading}
        error={error}
        actions={actions}
        tabs={tabConfig}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        searchPlaceholder="Anfrage suchen…"
        emptyText={activeTab === "open" ? "Keine offenen Anfragen." : "Keine abgeschlossenen Anfragen."}
        initialPageSize={25}
        pageSizeOptions={[10, 25, 50]}
      />
      <br />
    </div>
  );
};

export default ZRHaesApplies;
